import React from 'react';
import Icon from '../../../components/AppIcon';

const ComplianceOverview = ({ data }) => {
  const getComplianceScore = () => {
    if (!data || data?.length === 0) return 0;
    const totalAdherence = data?.reduce((sum, item) => sum + (item?.adherence_level || 0), 0);
    return Math.round(totalAdherence / data?.length);
  };

  const complianceScore = getComplianceScore();
  const compliantCount = data?.filter(d => d?.compliance_status === 'compliant')?.length || 0;
  const nonCompliantCount = data?.filter(d => d?.compliance_status === 'non_compliant')?.length || 0;
  const pendingCount = data?.filter(d => d?.compliance_status === 'pending_review')?.length || 0;

  const statCards = [
    { label: 'Compliance Score', value: `${complianceScore}%`, icon: 'Award', color: 'var(--color-success)' },
    { label: 'Compliant', value: compliantCount, icon: 'CheckCircle', color: 'var(--color-success)' },
    { label: 'Non-Compliant', value: nonCompliantCount, icon: 'XCircle', color: 'var(--color-error)' },
    { label: 'Pending Review', value: pendingCount, icon: 'Clock', color: 'var(--color-warning)' }
  ];

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {statCards?.map((stat, index) => (
          <div key={index} className="card">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-muted-foreground mb-1">{stat?.label}</p>
                <p className="text-3xl font-heading font-bold text-foreground">{stat?.value}</p>
              </div>
              <div
                className="w-12 h-12 rounded-lg flex items-center justify-center"
                style={{ backgroundColor: `${stat?.color}15` }}
              >
                <Icon name={stat?.icon} size={24} color={stat?.color} />
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="card">
        <h3 className="text-lg font-heading font-semibold text-foreground mb-4">
          Compliance Status by Regulation
        </h3>
        <div className="space-y-3">
          {data?.length === 0 ? (
            <div className="text-center py-12">
              <Icon name="FileText" size={48} className="mx-auto mb-4 text-muted-foreground" />
              <p className="text-muted-foreground">No compliance data available</p>
            </div>
          ) : (
            data?.map((item) => (
              <div key={item?.id} className="p-4 bg-muted/30 rounded-lg">
                <div className="flex items-center justify-between mb-2">
                  <h4 className="text-sm font-medium text-foreground">{item?.regulation_name}</h4>
                  <span
                    className="px-2 py-0.5 rounded text-xs font-medium"
                    style={{
                      backgroundColor:
                        item?.compliance_status === 'compliant' ?'var(--color-success)15'
                          : item?.compliance_status === 'non_compliant' ?'var(--color-error)15' :'var(--color-warning)15',
                      color:
                        item?.compliance_status === 'compliant' ?'var(--color-success)'
                          : item?.compliance_status === 'non_compliant' ?'var(--color-error)' :'var(--color-warning)'
                    }}
                  >
                    {item?.compliance_status?.replace(/_/g, ' ')}
                  </span>
                </div>
                <div className="flex items-center gap-4 text-xs text-muted-foreground">
                  <span>Adherence: {item?.adherence_level || 0}%</span>
                  <span>Risk: {item?.risk_level || 'N/A'}</span>
                  <span>Violations: {item?.violations_count || 0}</span>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default ComplianceOverview;